function applyNoticesClickHandler() {
  let notices = $(
    ".woocommerce-error , .woocommerce-info, .woocommerce-message"
  );
  if (notices) {
    let closeButtons = notices.find(".remove-notice");
    closeButtons.on("click", function () {
      let $this = $(this);
      $this.parent().slideUp();

      if ($(this).parent().is("li")) {
        var parentLi = $(this).parent();
        var parentUl = parentLi.parent();

        if (parentUl.children("li").filter(":visible").length === 1) {
          parentUl.slideUp();
        }
      }
    });
  }
}

jQuery(window).ready(function ($) {
  applyNoticesClickHandler();
});

jQuery(window).ajaxComplete(function ($) {
  applyNoticesClickHandler();
});
